import React, { useCallback, useEffect } from 'react'

import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withContainer = Component => props => {
  const [gsm] = hooks.useFieldValues(['user.gsm'])

  const [ordersCount, searchOrder] = hooks.useModelSearchCount('order', 'get', { populate: [] })
  const [jobs, searchJob] = hooks.useModelSearch('job', 'get', { populate: ['orders'] })

  const [user_id] = hooks.useFormState('user_id')
  const [job_id] = hooks.useFormState('job_id')
  const { display: canDisplayClient } = hooks.usePageAuthorization('/client')
  const { display: canDisplayJob } = hooks.usePageAuthorization('/job')
  const handleClickClientDetail = useCallback(Callbacks.handleClickClientDetailHandler(user_id), [user_id])
  const handleClickClientHistory = useCallback(Callbacks.handleClickClientHistoryHandler(gsm), [gsm])
  const handleClickOrderJob = useCallback(Callbacks.handleClickOrderJobHandler(job_id), [job_id])

  useEffect(() => {
    !!user_id && searchOrder({ do: user_id, confirmed: true, status: { '!': ['canceled', 'complete'] } })
  }, [user_id])

  useEffect(() => {
    !!job_id && searchJob({ job_id })
  }, [job_id])

  const mergedProps = {
    ordersCount,
    jobOrdersCount: (_.head(jobs)?.orders || []).length,
    handleClickClientDetail,
    handleClickClientHistory,
    handleClickOrderJob,
    hasJob: !!job_id,
    hasUser: !!user_id,
    canDisplayClient,
    canDisplayJob
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}

export default withContainer
